import React from 'react';
import { Link } from 'react-router-dom';
import { formatDistanceToNow } from 'date-fns';
import { ar } from 'date-fns/locale';
import './JobCard.css';

const JOB_TYPE_LABELS = {
  full_time: 'دوام كامل', part_time: 'دوام جزئي',
  contract: 'عقد', freelance: 'عمل حر', internship: 'تدريب'
};

const JobCard = ({ job }) => {
  const timeAgo = formatDistanceToNow(new Date(job.created_at), { addSuffix: true, locale: ar });

  return (
    <Link to={`/jobs/${job.uuid}`} className="job-card card">
      {job.is_featured && <div className="featured-tag">⭐ مميز</div>}
      <div className="job-card-body">
        <div className="flex gap-12 mb-16">
          <div className="org-logo-wrap">
            {job.org_logo ? (
              <img src={job.org_logo} alt={job.org_name} className="org-logo" />
            ) : (
              <div className="org-logo-placeholder">{(job.org_name || job.poster_name)?.[0]}</div>
            )}
          </div>
          <div>
            <h3 className="job-title">{job.title}</h3>
            <div className="job-org">{job.org_name || job.poster_name}</div>
          </div>
        </div>

        <div className="job-meta">
          {job.location_city && (
            <span className="meta-item">📍 {job.location_city}{job.location_country && `, ${job.location_country}`}</span>
          )}
          {job.is_remote && <span className="meta-item remote-tag">🌐 عن بُعد</span>}
          <span className="meta-item">🏃 {job.sport_category || 'رياضة'}</span>
        </div>

        <div className="job-tags">
          <span className={`badge badge-primary`}>{JOB_TYPE_LABELS[job.job_type]}</span>
          {job.experience_required > 0 && (
            <span className="badge badge-secondary">{job.experience_required}+ سنوات</span>
          )}
        </div>

        {job.salary_min || job.salary_max ? (
          <div className="job-salary">
            💰 {job.salary_min && job.salary_max ? `${job.salary_min} - ${job.salary_max}` : job.salary_max || job.salary_min} {job.salary_currency || 'USD'}
            <span className="salary-period">/{job.salary_period === 'monthly' ? 'شهرياً' : 'سنوياً'}</span>
          </div>
        ) : null}
      </div>
      <div className="job-card-footer">
        <span className="time-ago">{timeAgo}</span>
        <span className="applications-count">👥 {job.applications_count || 0} متقدم</span>
      </div>
    </Link>
  );
};

export default JobCard;
